import { render, staticRenderFns } from "./jlppDetail.vue?vue&type=template&id=0d92d570&scoped=true"
import script from "./jlppDetail.vue?vue&type=script&lang=js"
export * from "./jlppDetail.vue?vue&type=script&lang=js"
import style0 from "./jlppDetail.vue?vue&type=style&index=0&id=0d92d570&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d92d570",
  null
  
)

export default component.exports